export const mockCharacterData = {
    GarantiasReais: {
        AlienacaoFiduciaria: {
            Valor: "1.000.000.000,00",
            Bens: ["Imóvel", "Participações"],
        },

        CessaoFiduciaria: {
            Quantidade: "1",
            Descricao:
                "Direitos Creditórios oriundos de cada Contrato",
        },

        FiancaBancaria: null,

        Hipoteca: {
            Instituicao: "Itaú Unibanco S.A.",
            CNPJ: "60.701.190/0001-04",
        },

        Penhor: null,
    },

    GarantiasFidejussorias: {
        Aval: null,
        Fianca: null,
    },

    MitigadoresRiscoCredito: {
        FundoObra: "12.345.678",
        FundoReserva: null,
        FundoLiquidez: null,
        SobreGarantias: null,
        Seguro: null,
        CotasInferiores: [
            "23LI229574",
            "24E1703996",
            "24H1939132",
            "25C4212193",
            "25L3013425",
        ],
    },

    LTV: {
        DataReferencia: "15/05/2025",
        Valor: "120,00",
    },

    TipoOferta: "Oferta Pública",

    DataReferenciaFatoRelevante: "15/05/2025",

    FatoRelevante:
        "Emissão com garantias reais e mitigadores de risco conforme documentação.",
}